import { FondsPropresService } from "src/app/fonds-propres/services/fonds-propres.service";
import { SegmentStatistique } from "../../../models/SegmentStatistique";
import { ChartType, ChartDataSets, ChartOptions, ChartData } from "chart.js";
import { BaseChartDirective, Label } from "ng2-charts";
import { PortefeuilleDetail } from "../../../models/PortefeuilleDetail";
import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { Portefeuille } from "../../../models/Portefeuille";
import * as pluginDataLabels from "chartjs-plugin-datalabels";

@Component({
  selector: "app-benchmark",
  templateUrl: "./benchmark.component.html",
  styleUrls: ["./benchmark.component.scss"],
})
export class BenchmarkComponent implements OnInit {
  isLoadingResults = false;

  @Input("segmentStatistiques")
  set segmentStatistiques(value: SegmentStatistique[]) {
    this.formattedChartDatas(value);
  }

  @Input()
  portefeuilles: Portefeuille[] = [];
  @Input()
  portefeuille: Portefeuille;

  selectedPortefeuilleId: number;
  segmentStatistiquesBenchMark: SegmentStatistique[] = [];

  constructor(private shared: FondsPropresService) {}
  /** Portefeuille A datas */
  totalCumulApr: number = 0;
  totalCumulFondpropre: number = 0;
  cumulCreanceSaines: number = 0;
  cumulCreanceEnSouffrance: number = 0;
  cumulProvisions: number = 0;
  cumulEngagementHorsBilan: number = 0;
  cumulCreanceNettes: number = 0;
  nombreLigneCredit: number = 0;
  /** Portefeuille B datas */
  benchMarkTotalCumulApr: number = 0;
  benchMarkTotalCumulFondpropre: number = 0;
  benchMarkCumulCreanceSaines: number = 0;
  benchMarkCumulCreanceEnSouffrance: number = 0;
  benchMarkCumulProvisions: number = 0;
  benchMarkCumulEngagementHorsBilan: number = 0;
  benchMarkCumulCreanceNettes: number = 0;
  benchMarkNombreLigneCredit: number = 0;
  /** PortefeuilleFin datas */

  barChartLabels: Label[] = [];
  barChartType: ChartType = "bar";
  barChartLegend = true;
  barChartPlugins = [];
  barChartData: ChartDataSets[] = [];
  @ViewChild(BaseChartDirective, { static: false }) chart: BaseChartDirective;

  ngOnInit() {}

  ChangeSelectedPortefeuille() {
    //this.selectedPortefeuille = selected.id + '--' + selected.libelle;
    this.getPortefeuilleSegmentStatistiqueBenchMark(
      this.selectedPortefeuilleId
    );
  }

  getPortefeuilleSegmentStatistiqueBenchMark(portefeuilleId: number) {
    this.isLoadingResults = true;
    this.shared.getPortefeuilleSegmentStatistique(portefeuilleId).subscribe(
      (data) => {
        this.segmentStatistiquesBenchMark = data;
      },
      (error) => {
        console.log("error", error);
        this.isLoadingResults = false;
      },
      () => {
        if (this.segmentStatistiquesBenchMark == null) {
          this.segmentStatistiquesBenchMark = [];
        }
        this.formattedChartDatasBenchMark(this.segmentStatistiquesBenchMark);
        this.isLoadingResults = false;
      }
    );
  }

  formattedChartDatas(data: SegmentStatistique[]) {
    this.totalCumulApr = 0;
    this.totalCumulFondpropre = 0;
    this.cumulCreanceSaines = 0;
    this.cumulCreanceEnSouffrance = 0;
    this.cumulProvisions = 0;
    this.cumulEngagementHorsBilan = 0;
    this.cumulCreanceNettes = 0;
    this.nombreLigneCredit = 0;
    if (data) {
      data.forEach((element) => {
        this.totalCumulApr = this.totalCumulApr + element.cumulApr;
        this.totalCumulFondpropre =
          this.totalCumulFondpropre + element.cumulFondpropre;
        this.cumulCreanceSaines =
          this.cumulCreanceSaines + element.cumulCreanceSaines;
        this.cumulCreanceEnSouffrance =
          this.cumulCreanceEnSouffrance + element.cumulCreanceEnSouffrance;
        this.cumulProvisions = this.cumulProvisions + element.cumulProvisions;
        this.cumulEngagementHorsBilan =
          this.cumulEngagementHorsBilan + element.cumulEngagementHorsBilan;
        this.cumulCreanceNettes =
          this.cumulCreanceNettes + element.cumulCreanceNettes;
        this.nombreLigneCredit =
          this.nombreLigneCredit + element.nombreLigneCredit;
      });
    }
    this.refreshData();
  }

  formattedChartDatasBenchMark(data: SegmentStatistique[]) {
    this.benchMarkTotalCumulApr = 0;
    this.benchMarkTotalCumulFondpropre = 0;
    this.benchMarkCumulCreanceSaines = 0;
    this.benchMarkCumulCreanceEnSouffrance = 0;
    this.benchMarkCumulProvisions = 0;
    this.benchMarkCumulEngagementHorsBilan = 0;
    this.benchMarkCumulCreanceNettes = 0;
    this.benchMarkNombreLigneCredit = 0;

    if (data) {
      data.forEach((element) => {
        this.benchMarkTotalCumulApr =
          this.benchMarkTotalCumulApr + element.cumulApr;
        this.benchMarkTotalCumulFondpropre =
          this.benchMarkTotalCumulFondpropre + element.cumulFondpropre;
        this.benchMarkCumulCreanceSaines =
          this.benchMarkCumulCreanceSaines + element.cumulCreanceSaines;
        this.benchMarkCumulCreanceEnSouffrance =
          this.benchMarkCumulCreanceEnSouffrance +
          element.cumulCreanceEnSouffrance;
        this.benchMarkCumulProvisions =
          this.benchMarkCumulProvisions + element.cumulProvisions;
        this.benchMarkCumulEngagementHorsBilan =
          this.benchMarkCumulEngagementHorsBilan +
          element.cumulEngagementHorsBilan;
        this.benchMarkCumulCreanceNettes =
          this.benchMarkCumulCreanceNettes + element.cumulCreanceNettes;
        this.benchMarkNombreLigneCredit =
          this.benchMarkNombreLigneCredit + element.nombreLigneCredit;
      });
    }
    this.refreshData();
  }

  refreshData() {
    this.barChartLabels = [
      "Créances saines",
      "Créances en souffrance",
      "Provisions",
      "Créances nettes",
      "Engagements hors-bilan",
      "APR",
      "FP",
    ];

    this.barChartData = [
      {
        label: " Portefeuille A",
        data: [
          this.cumulCreanceSaines,
          this.cumulCreanceEnSouffrance,
          this.cumulProvisions,
          this.cumulCreanceNettes,
          this.cumulEngagementHorsBilan,
          this.totalCumulApr,
          this.totalCumulFondpropre,
        ],
      },
      {
        label: " Portefeuille B",
        data: [
          this.benchMarkCumulCreanceSaines,
          this.benchMarkCumulCreanceEnSouffrance,
          this.benchMarkCumulProvisions,
          this.benchMarkCumulCreanceNettes,
          this.benchMarkCumulEngagementHorsBilan,
          this.benchMarkTotalCumulApr,
          this.benchMarkTotalCumulFondpropre,
        ],
      },
    ];
  }

  public barChartOptions: ChartOptions = {
    responsive: true,
    elements: {
      line: {
        tension: 0.4,
      },
    },
    scales: {
      xAxes: [{}],
      yAxes: [
        {
          ticks: {
            callback: function (value, index, values) {
              return Intl.NumberFormat("fr-FR").format(Number(value));
            },
          },
        },
      ],
    },
    tooltips: {
      enabled: true,
      callbacks: {
        label: function (tooltipItem, data) {
          //let label = data.labels[tooltipItem.index];
          let value =
            data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
          let legend = data.datasets[tooltipItem.datasetIndex].label;
          return (
            " " +
            legend +
            ": " +
            Intl.NumberFormat("fr-FR", {
              maximumFractionDigits: 0,
              minimumFractionDigits: 0,
            }).format(Number(value))
          );
        },
      },
    },
    plugins: {
      legend: { display: true },
      datalabels: {
        anchor: "end",
        align: "end",
      },
    },
  };
}
